(function($){
    $('.sidebar-menu .menu-item-has-children > a').on('click', function(e){
        e.preventDefault();
        $(this).next('.sub-menu').slideToggle(500);
        $(this).toggleClass('active');
    })
})(jQuery)